<script>
    import {tick} from "svelte";
    import PeopleChooser from "../PeopleChooser.svelte";
    import {PAGE_ID, router, navigateTo, PAGE_DATA} from "../../stores/router";
    import {getNullPromotion, I_DEAL, I_PERSON, I_PROMOTION, PROMOTION_LABELS, PROMOTION_EXPLANATION, promotionAsObject} from "../../../../../../lib/datatypes";
    import {people} from "../../stores/people";
    import {deals} from "../../stores/deals";
    import {app_state, addPromotion, selectPromotion} from "../../stores/misc";
    import {isoDateNow} from "../../../../../../lib/dates_times";

    const getEmptyPromotion = () => {
        let result = promotionAsObject(getNullPromotion());
        return result;
    }
    let add_promotion = getEmptyPromotion();
    let return_page_name = '';

    // NB pulled this out into function to prevent reactivity updating on every change to add_promotion
    const updatePromotionWithContextualDealID = () => {
        add_promotion.id_deal = $router.context.id_deal;
    };
    // When this page is navigated to - set the id_deal from the navigation context
    $: if($router.current_page === PAGE_ID.ADD_PROMOTION) {
        if($router['context'] === null || $router['context']['id_deal'] === undefined) {
            throw new Error('AddPromotionPage expects a router.context.id_deal value - otherwise we do not know which deal to assign');
        }
        updatePromotionWithContextualDealID();
        return_page_name = PAGE_DATA[$router.context.previous_page_id].name;
        // console.log('update add_promotion.id_deal triggered (should be when page changes):');
    }


    const doAddPromotion = async () => {
        let result = await addPromotion(add_promotion);
        add_promotion = getEmptyPromotion();
        await tick();

        selectPromotion(result[I_PROMOTION.ID]);
        navigateTo(PAGE_ID.VIEW_PROMOTION);
    };

    const onBackClick = () => {
        if($router.context.previous_page_id !== null) {
            navigateTo($router.context.previous_page_id, PAGE_ID.DEALS);  // NB we set this to DEALS because we don't want a back loop where people come back here without context
        }
        else {
            navigateTo(PAGE_ID.PROMOTIONS);
        }
        add_promotion = getEmptyPromotion();
    };
</script>


<div class="absolute top-16 right-0 bottom-0 left-0 overflow-y-auto" class:hidden={$router.current_page !== PAGE_ID.ADD_PROMOTION}>

    <!-- Header -->
    <div class="px-4 sm:px-6 lg:px-8">

        <!--<Breadcrumbs></Breadcrumbs>-->

        <div class="h-16 flex items-center justify-between">
            <a on:click|preventDefault={onBackClick} href="/" class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
                <svg class="-ml-1 mr-1 h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clip-rule="evenodd" />
                </svg>
                Back
            </a>
        </div>

    </div>

    <div class="px-4 sm:px-6 lg:px-8">

        <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">Add Promotion</h2>

        <div class="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-6 sm:gap-x-6">

            <div class="flex items-baseline">
                <p class="text-sm text-gray-500">For Deal:</p>
                <p class="ml-2 text-lg font-medium text-gray-900">{add_promotion.id_deal === '' ? '' : $deals.lookup[add_promotion.id_deal][I_DEAL.TITLE]}</p>
            </div>

            <p class="text-sm font-medium text-gray-600">{@html PROMOTION_EXPLANATION}</p>

            <div class="mt-4">
                <label for="promotion-title" class="block text-sm font-medium text-gray-900">Promotion Title</label>
                <input bind:value="{add_promotion.title}" type="text" name="promotion-title" id="promotion-title" class="mt-1 block w-full rounded-md border-gray-300 text-gray-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
                <p class="mt-3 text-sm italic text-gray-500">({@html PROMOTION_LABELS.TITLE})</p>
            </div>

            <div class="mt-4">
                <label for="description" class="block text-sm font-medium text-gray-900">Description</label>
                <div class="mt-1">
                    <textarea bind:value={add_promotion.description}
                              id="description" name="description" rows="4"
                              class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"></textarea>
                </div>
                <p class="mt-3 text-sm italic text-gray-500">({@html PROMOTION_LABELS.DESCRIPTION})</p>
            </div>

        </div>

        <div class="flex justify-end pt-8">
            <button on:click={onBackClick}
                    type="button"
                    class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >Cancel</button>
            <button on:click={doAddPromotion}
                    type="submit"
                    class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >Save</button>
        </div>

    </div>

</div>


<style></style>